'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _subaccounts = require('redux/modules/subaccounts');

var _auth = require('redux/modules/auth');

var _Allow = require('../Allow/Allow');

var _Allow2 = _interopRequireDefault(_Allow);

var _Snackbar = require('../../components/Snackbar/Snackbar');

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _reactDatetime = require('react-datetime');

var _reactDatetime2 = _interopRequireDefault(_reactDatetime);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require('react-router');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _translations = require('translations');

var _translations2 = _interopRequireDefault(_translations);

var _reduxConnect = require('redux-connect');

var _reactRedux = require('react-redux');

var _account = require('redux/modules/account');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reachHistory = require('../../helpers/reachHistory');

var _PrepaidCharges = require('./PrepaidCharges.scss');

var _PrepaidCharges2 = _interopRequireDefault(_PrepaidCharges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md = {
  arrowBack: require('react-icons/lib/md/arrow-back')
};

var PrepaidCharges = (_dec = (0, _reduxConnect.asyncConnect)([{
  key: 'account',
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var state = getState();
    if (!state.account.data.reach) {
      return dispatch((0, _account.getAccount)());
    }
    return null;
  }
}, {
  key: "auth",
  promise: function promise(_ref2) {
    var _ref2$store = _ref2.store,
        dispatch = _ref2$store.dispatch,
        getState = _ref2$store.getState;

    if (!(0, _auth.isLoaded)(getState())) {
      return dispatch((0, _auth.load)());
    }
    return null;
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    account: state.auth.current_account, user: state.auth.data.user
  };
}, { getAccount: _account.getAccount, pushState: _reachHistory.push, addSubaccountCharge: _subaccounts.addSubaccountCharge, getSubaccountCharge: _subaccounts.getSubaccountCharge }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(PrepaidCharges, _React$Component);

  function PrepaidCharges(props) {
    (0, _classCallCheck3.default)(this, PrepaidCharges);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PrepaidCharges.__proto__ || (0, _getPrototypeOf2.default)(PrepaidCharges)).call(this, props));

    _this.queue = [];

    _this.state = {
      account: null,
      account_uid: null,
      credit_limit: 0,
      valid_since: (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss'),
      channel_identifier: null,
      source_uid: null,
      listCharges: null,
      account_id: _this.props.account.account_uid,
      account_type: _this.props.account.account_type,
      showSnackbar: false,
      snackMessage: null,
      snackStatus: null
    };
    return _this;
  }

  (0, _createClass3.default)(PrepaidCharges, [{
    key: 'mapCharges',
    value: function mapCharges(account_balance) {
      var charges = account_balance.charges;
      var refunds = account_balance.refunds;
      var consumido = charges - refunds;
      var valid_since = (0, _moment2.default)(account_balance.billing_cycle.valid_since);
      var valid_thru = (0, _moment2.default)(account_balance.billing_cycle.valid_thru);
      var now = (0, _moment2.default)();
      var estado = void 0;
      if (valid_since < now && now < valid_thru) {
        estado = (0, _translations2.default)("ACTIVE");
      } else if (now < valid_since) {
        estado = (0, _translations2.default)("PENDING");
      } else {
        estado = (0, _translations2.default)("EXPIRED");
      }
      account_balance.vigente = estado;
      account_balance.consumed = consumido;
      return account_balance;
    }
  }, {
    key: 'componentDidMount',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var account_id, chargesList, arrCharges, account, uid, channel, id, _account_id, _chargesList, _arrCharges;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.state.account_type == 'Reseller')) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 1;
                account_id = this.props.location.state.account.reach._id;
                _context.next = 5;
                return this.props.getSubaccountCharge(account_id);

              case 5:
                chargesList = _context.sent;
                arrCharges = chargesList.map(this.mapCharges);

                this.setState({ listCharges: arrCharges });
                if (this.props.location.state.account) {
                  account = this.props.location.state.account.reach;
                  uid = account._id;
                  channel = account.router.router_sources[0].channel_identifier;
                  id = account.router.router_sources[0]._id;


                  this.setState({
                    account: this.props.location.state.account.reach,
                    account_uid: uid,
                    channel_identifier: channel,
                    source_uid: id
                  });
                }

                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                console.log((0, _translations2.default)("NO ACCOUNT CHARGES DATA"), _context.t0);
                this.props.pushState({
                  pathname: '/fail',
                  state: {
                    goTo: '/reseller',
                    message: (0, _translations2.default)("NO ACCOUNT CHARGES DATA"),
                    goToModal: false,
                    returnTo: '/reseller'
                  }
                });

              case 15:
                _context.next = 23;
                break;

              case 17:
                _account_id = this.state.account_id;
                _context.next = 20;
                return this.props.getSubaccountCharge(_account_id);

              case 20:
                _chargesList = _context.sent;
                _arrCharges = _chargesList.map(this.mapCharges);

                this.setState({ listCharges: _arrCharges });

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 11]]);
      }));

      function componentDidMount() {
        return _ref3.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'refreshList',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var chargesList, arrCharges;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.props.getSubaccountCharge(this.state.account_uid);

              case 2:
                chargesList = _context2.sent;
                arrCharges = chargesList.map(this.mapCharges);

                this.setState({ listCharges: arrCharges });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refreshList() {
        return _ref4.apply(this, arguments);
      }

      return refreshList;
    }()
  }, {
    key: 'limit',
    value: function limit(event) {
      var value = event.target.value;
      this.setState({ credit_limit: value });
    }
  }, {
    key: 'validSince',
    value: function validSince(date) {
      this.setState({ valid_since: date });
    }
  }, {
    key: 'showSnackBar',
    value: function showSnackBar(message, status) {
      var _this2 = this;

      this.setState({ snackMessage: message });
      this.setState({ snackStatus: status });
      this.setState({ showSnackbar: true });
      setTimeout(function () {
        _this2.setState({ showSnackbar: false });
      }, 1850);
    }
  }, {
    key: 'addCharge',
    value: function addCharge() {
      var _this3 = this;

      if (this.state.credit_limit > 0) {
        var data = {
          account_uid: this.state.account_uid,
          valid_since: this.state.valid_since,
          channel_indentifier: this.state.channel_identifier,
          source_uid: this.state.source_uid,
          package: {
            credit_limit: this.state.credit_limit,
            credit_base_limit: this.state.credit_limit
          },
          created_by: this.props.user.email
        };
        return this.props.addSubaccountCharge(data).then(function (result) {
          console.log('recarga añadida a la cuenta');
          _this3.showSnackBar((0, _translations2.default)('CHARGE ADDED'), 'success');
          _this3.refreshList();
        }).catch(function (e) {
          console.error((0, _translations2.default)('COULD NOT ADD CHARGE'), e);
          _this3.showSnackBar((0, _translations2.default)('COULD NOT ADD CHARGE'), 'error');
        });
      } else {
        this.showSnackBar((0, _translations2.default)('CHARGE MUST BE GREATER THAN 0'), 'warning');
      }
    }
  }, {
    key: 'renderNewCharge',
    value: function renderNewCharge() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          { className: _PrepaidCharges2.default.title },
          (0, _translations2.default)("ADD NEW CHARGE")
        ),
        _react2.default.createElement(
          'div',
          { style: { padding: '0px 25px' } },
          _react2.default.createElement(
            'div',
            { className: _PrepaidCharges2.default.newCharge },
            _react2.default.createElement(
              'div',
              { style: { width: '25%' } },
              _react2.default.createElement(
                'h3',
                { className: _PrepaidCharges2.default.subtitle },
                (0, _translations2.default)("ACCOUNT SMS LIMIT")
              ),
              _react2.default.createElement('input', { type: 'number', className: _PrepaidCharges2.default.creditInput,
                value: this.state.credit_limit,
                onChange: function onChange(value) {
                  return _this4.limit(value);
                } })
            ),
            _react2.default.createElement(
              'div',
              { className: _PrepaidCharges2.default.date },
              _react2.default.createElement(
                'h3',
                { className: _PrepaidCharges2.default.subtitle },
                (0, _translations2.default)("CREDIT DATE")
              ),
              _react2.default.createElement(_reactDatetime2.default, { value: this.state.valid_since, onChange: this.validSince.bind(this) })
            ),
            _react2.default.createElement(
              'button',
              { className: _PrepaidCharges2.default.button, onClick: function onClick() {
                  return _this4.addCharge();
                } },
              (0, _translations2.default)("ADD CHARGE")
            )
          ),
          _react2.default.createElement('hr', { style: { border: '1px solid #eee', margin: 0 } })
        )
      );
    }
  }, {
    key: 'renderChargesTable',
    value: function renderChargesTable() {
      var number_width = 200;
      var columns = [{
        Header: (0, _translations2.default)("CHARGE DATE"),
        accessor: 'billing_cycle.valid_since',
        width: number_width,
        Cell: function Cell(props) {
          return _react2.default.createElement(
            'span',
            null,
            (0, _moment2.default)(props.value).utc().format('DD/MM/YYYY')
          );
        }
      }, {
        Header: (0, _translations2.default)("EXPIRATION DATE"),
        accessor: 'billing_cycle.valid_thru',
        width: number_width,
        Cell: function Cell(props) {
          return _react2.default.createElement(
            'span',
            null,
            (0, _moment2.default)(props.value).utc().format('DD/MM/YYYY')
          );
        }
      }, {
        Header: (0, _translations2.default)("HIRED"),
        accessor: 'credit_limit',
        width: '1f'
      }, {
        Header: (0, _translations2.default)("AVAILABLE"),
        accessor: 'balance',
        width: '1f'
      }, {
        Header: (0, _translations2.default)("ESPENDED"),
        accessor: 'consumed',
        width: '1f'
      }, {
        Header: (0, _translations2.default)("STATUS"),
        accessor: 'vigente',
        width: '1f'
      }, {
        Header: (0, _translations2.default)("CREATED_BY"),
        accessor: 'created_by',
        width: '200',
        Cell: function Cell(props) {
          return _react2.default.createElement(
            'span',
            { className: _PrepaidCharges2.default.wrapper },
            props.value
          );
        }
      }];
      if (this.state.listCharges != null) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            { className: _PrepaidCharges2.default.title },
            (0, _translations2.default)("CHARGES MADE")
          ),
          _react2.default.createElement(
            'div',
            { className: _PrepaidCharges2.default.table },
            _react2.default.createElement(_components.Table, {
              data: this.state.listCharges,
              columns: columns,
              isLoading: false
            })
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var link = void 0;
      var title = void 0;

      if (this.state.account_type == 'Reseller') {
        link = '/reseller';
        title = (0, _translations2.default)("CHARGES") + ' ' + (0, _translations2.default)("OF") + ' ' + this.props.location.state.account.reach.name;
      } else {
        link = '/reports';
        title = (0, _translations2.default)("CHARGES");
      }
      return _react2.default.createElement(
        'div',
        { className: _PrepaidCharges2.default.main },
        _react2.default.createElement(_Snackbar2.default, {
          messageText: this.state.snackMessage,
          variant: this.state.snackStatus,
          isOpen: this.state.showSnackbar
        }),
        _react2.default.createElement(_reactHelmet2.default, { title: title }),
        _react2.default.createElement(
          'div',
          { className: _PrepaidCharges2.default.body },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: link },
            _react2.default.createElement(md.arrowBack, { size: 20, color: _PrepaidCharges2.default.primary, style: { verticalAlign: 'middle',
                position: 'absolute', marginTop: '9px' } })
          ),
          _react2.default.createElement(
            _Allow2.default,
            { permissions: ['reseller:subaccount:charges:add'] },
            this.state.account_type == 'Reseller' ? this.renderNewCharge() : null
          ),
          this.renderChargesTable()
        )
      );
    }
  }]);
  return PrepaidCharges;
}(_react2.default.Component)) || _class) || _class);
exports.default = PrepaidCharges;
module.exports = exports['default'];